import FormPageFake, {
  THEMES as FAKE_THEMES,
} from '@/components/fakes/formPagesFake';
import { FROM_TEMPLATE_THEMES } from '@/components/fakes/formTemplateFake';
import { grid } from '@/constants/grid';

function FormAccount({ withHeader = false }) {
  return (
    <>
      {withHeader && <div className="header-fake skeleton" />}
      <FormPageFake
        formTemplateFakes={[
          {
            theme: FAKE_THEMES.textList,
            fakeLength: 3,
            formTemplateTheme: FROM_TEMPLATE_THEMES.FULL,
          },
          {
            withTitle: false,
            fakeLength: 2,
            formTemplateTheme: FROM_TEMPLATE_THEMES.FULL,
          },
        ]}
      />
      <style jsx>
        {`
          .header-fake {
            width: 50%;
            height: 38px;
            border-radius: 4px;
            margin-top: 18px;
            margin-bottom: 56px;
            position: relative;
            left: 25%;
          }
          @media screen and (min-width: ${grid.breakpoint_sm}px) {
            .header-fake {
              height: 52px;
            }
          }
        `}
      </style>
    </>
  );
}
export default FormAccount;
